import emailjs from "@emailjs/browser";
import { useEffect } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

export default function PaymentSuccess() {
  useEffect(() => {
    const saveOrder = async () => {
      try {
        console.log("PaymentSuccess çalıştı");

        const orderId = localStorage.getItem("pendingOrderId");
        const cartRaw = localStorage.getItem("pendingCart");
        const formRaw = localStorage.getItem("pendingForm");

        console.log("pendingOrderId:", orderId);
        console.log("pendingCart raw:", cartRaw);
        console.log("pendingForm raw:", formRaw);

        const cart = JSON.parse(cartRaw || "[]");
        const form = JSON.parse(formRaw || "{}");

        console.log("cart parsed:", cart);
        console.log("form parsed:", form);

        if (!orderId || !form?.email) {
          console.error("Sipariş verisi eksik");
          return;
        }

        const total = cart.reduce((sum, item) => {
          return sum + Number(item.price || 0) * Number(item.quantity || 1);
        }, 0);

        await addDoc(collection(db, "orders"), {
          orderId,
          name: form.name || "",
          email: form.email || "",
          phone: form.phone || "",
          address: form.address || "",
          basketItems: cart,
          total,
          status: "Hazırlanıyor",
          paymentStatus: "paid",
          createdAt: serverTimestamp()
        });

        console.log("Firestore sipariş kaydedildi");

        const mailSentKey = `mail_sent_${orderId}`;
        const alreadySent = localStorage.getItem(mailSentKey);

        if (!alreadySent) {
          await emailjs.send(
            "service_xgwc6vx",
            "template_ulajfxj",
            {
              to_email: form.email || "",
              customer_name: form.name || "",
              order_id: orderId,
              total: total,
              address: form.address || ""
            },
            "VD02a_cdpdoQ2spNU"
          );

          localStorage.setItem(mailSentKey, "true");
          console.log("Mail gönderildi");
        }

        localStorage.removeItem("pendingOrderId");
        localStorage.removeItem("pendingCart");
        localStorage.removeItem("pendingForm");

        console.log("Sipariş süreci tamamlandı");
      } catch (error) {
        console.error("Sipariş kaydedilemedi:", error);
      }
    };

    saveOrder();
  }, []);

  return (
  <div
    style={{
      minHeight: "60vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      padding: "120px 20px 60px",
      color: "#f5e7c6"
    }}
  >
    <h1
      style={{
        fontFamily: "inherit",
        fontSize: "42px",
        fontWeight: "700",
        letterSpacing: "1px",
        marginBottom: "16px"
      }}
    >
      Siparişiniz Alındı
    </h1>

    <p
      style={{
        fontFamily: "Grenze Gotisch",
        fontSize: "20px",
        lineHeight: "1.6",
        maxWidth: "700px",
        margin: 0
      }}
    >
      Siparişiniz başarıyla oluşturuldu. En kısa sürede hazırlanıp tarafınıza ulaştırılacaktır.
    </p>
  </div>
);
}